import { SortDirection } from 'global-constants';

export const DEFAULT_LIMIT = 25;
export const DEFAULT_COLLABORATOR_SORT_ORDER = {
  direction: SortDirection.ORDER_ASCENDING,
  field: 'lastName',
};
